import { render } from "./ComponentPlacePreguntas.vue?vue&type=template&id=67a45eee"
const script = {}

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__